import { createLazyComponent } from '@muse-web/router'

export const AsyncPaywallDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-paywall' */ './PaywallDialogContainer'),
    'PaywallDialogContainer',
)
